<template>
  <div class="flex flex-wrap items-center gap-2 border-b border-gray-200 pb-3">
    <div v-if="mode === 'tabs'" class="flex flex-wrap items-center gap-2" role="tablist" aria-label="Vendor">
      <span class="text-sm text-gray-600">Vendor</span>
      <button
        v-for="lane in ordered"
        :key="lane.vendorCode"
        type="button"
        role="tab"
        :aria-selected="lane.vendorCode === modelValue"
        class="rounded-lg border px-4 py-1.5 text-[13px] font-semibold"
        :class="lane.vendorCode === modelValue ? 'border-blue-600 bg-blue-600 text-white' : 'border-gray-300 bg-white text-gray-600 hover:border-blue-300 hover:text-blue-700'"
        :title="lane.vendorName"
        @click="emit('update:modelValue', lane.vendorCode)"
      >
        {{ lane.vendorCode }}
      </button>
    </div>
    <label v-else-if="mode === 'select'" class="flex items-center gap-2 text-sm text-gray-600">
      Vendor
      <select class="select !w-auto !py-1.5" :value="modelValue ?? ''" @change="emit('update:modelValue', ($event.target as HTMLSelectElement).value)">
        <option v-for="lane in ordered" :key="lane.vendorCode" :value="lane.vendorCode">{{ vendorOptionLabel(lane) }}</option>
      </select>
    </label>
    <span v-else-if="!hideSingle" class="text-sm text-gray-600">Vendor</span>
    <!-- The page's actions share this row: with the page heading gone there is nothing else
         to hang them off, and a row of their own would give back the space that removed. -->
    <div class="ml-auto flex flex-wrap items-center gap-2">
      <slot name="actions" />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  import { sortVendorOptions, vendorOptionLabel, vendorSwitcher, type VendorTabOption } from '@/utils/vendorSwitcher';

  const props = withDefaults(defineProps<{ lanes: VendorTabOption[]; modelValue: string | null; hideSingle?: boolean }>(), { hideSingle: false });
  const emit = defineEmits<{ 'update:modelValue': [vendorCode: string] }>();

  const ordered = computed(() => sortVendorOptions(props.lanes));
  const mode = computed(() => vendorSwitcher(props.lanes.length, props.hideSingle));
</script>
